import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import * as urls from '@cdba/shared/constants/urls';

@Component({
  selector: 'cdba-excluded-calculations-dialog',
  templateUrl: './excluded-calculations-dialog.component.html',
  styleUrls: ['./excluded-calculations-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExcludedCalculationsDialogComponent {
  data = inject<{
    numberOfUnauthorizedCalculations: number;
    missingCostRoles: string[];
    unauthorizedPlants: string[];
  }>(MAT_DIALOG_DATA);

  urlRoleAssignments = urls.URL_ROLE_ASSIGNMENTS;
  urlSams = urls.URL_SAMS_1;

  private readonly dialogRef = inject(
    MatDialogRef<ExcludedCalculationsDialogComponent>
  );

  onClose(): void {
    this.dialogRef.close();
  }

  readonly formatMissingCostRoles = (costRoles: string[]): string =>
    costRoles.map((costRole) => this.formatCostRole(costRole)).join(', ');

  private readonly formatCostRole = (costRole: string): string => {
    switch (costRole) {
      case 'CDBA_COST_TYPE_SQV': {
        return '<SD-INFORMATION_SAW>';
      }
      case 'CDBA_COST_TYPE_GPC': {
        return '<CO_PC-INFORMATION>';
      }
      default: {
        return costRole;
      }
    }
  };
}
